export enum ReportTimeTypeEnum {
  StartOfDay,
  EndOfDay
}
